import { useEffect } from "react";
import {
  useGetPageQueryParams,
  useMerchantApiQueryWithParams,
  usePaginationWithQueryString,
} from "../../../../hooks";
import {
  IPageAndSearchRequest,
  IViewPayoutListItem,
  PagedMeta,
} from "../../../../interfaces-and-types";
import { View } from "./View";

export const LINKED_PAYOUTS_LIST_TABLE_NAME = "transactionPayouts";
export const DEFAULT_PAGE_SIZE = 10;

interface ILinkedPayoutProps {
  tx_ref: string;
}

export const LinkedPayouts = ({ tx_ref }: ILinkedPayoutProps) => {
  const { page, page_size, search } = useGetPageQueryParams({
    queryStringPrefix: LINKED_PAYOUTS_LIST_TABLE_NAME,
  });

  // console.log("page in LinkedPayouts queryString: ", page);
  // console.log("page_size in LinkedPayouts queryString: ", page_size);
  // alert("page in LinkedPayouts queryString: " + page);
  // alert("page_size in LinkedPayouts queryString: " + page_size);

  const {
    isLoading: isLoadingTxPayouts,
    isError: isErrorTxPayouts,
    isSuccess: isSuccessTxPayouts,
    data: txPayouts,
    meta: txPayoutsMeta,
    refetch: refetchTxPayouts,
  } = useMerchantApiQueryWithParams<
    IPageAndSearchRequest,
    IViewPayoutListItem[],
    PagedMeta
  >(
    [
      "getPayoutsByTxRef",
      {
        page: (page && Number(page)) || 1,
        page_size: (page_size && Number(page_size)) || DEFAULT_PAGE_SIZE,
        search,
      },
    ],
    {
      enabled: !!tx_ref,
    },
    (urlTemplate) => urlTemplate.replace("{tx_ref}", tx_ref!)
  );

  // TODO: investigate and fix closure bug where linked payouts do not refresh when a link is clicked on "Other Payments From Customer"
  // useEffect(() => {
  //   refetchTxPayouts();
  // }, [tx_ref]);

  const paginationContext = usePaginationWithQueryString({
    queryStringFilterPrefix: LINKED_PAYOUTS_LIST_TABLE_NAME,
  });

  // TODO: enable after fixing bug on Backend causing page and pageSize not to be returned
  // useEffect(() => {
  //   if (isSuccessTxPayouts && txPayoutsMeta)
  //     paginationContext.syncWithApiResponse({
  //       apiResponsePage: txPayoutsMeta.page_meta.page,
  //       apiResponsePageSize: txPayoutsMeta.page_meta.page_size,
  //     });
  // }, [isSuccessTxPayouts]);

  return (
    <View
      isLoading={isLoadingTxPayouts}
      isError={isErrorTxPayouts}
      pageMeta={txPayoutsMeta?.page_meta}
      paginationContext={paginationContext}
      transactionPayouts={txPayouts || []}
    />
  );
};
